import React, { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FaBookOpen, FaArrowRight } from "react-icons/fa";
import DocsService from "../services/DocsService";
import { Context } from "../context/UserContext";

// Roles que enxergam apenas a documentação correspondente ao seu cliente.
// Outras roles (admin, user, etc.) recebem a lista completa.
// Ampliar esse mapa quando novos clientes ganharem documentação dedicada.
const ROLE_TO_DOC_SLUG = {
    vivogestao: "vivo",
    phx: "phx",
    sofia: "user",
};

export default function Docs() {
    const { user } = useContext(Context);
    const [docs, setDocs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        let alive = true;
        (async () => {
            try {
                const { docs } = await DocsService.listDocs();
                if (alive) setDocs(docs || []);
            } catch (err) {
                if (alive) setError("Erro ao carregar a lista de documentações.");
            } finally {
                if (alive) setLoading(false);
            }
        })();
        return () => { alive = false; };
    }, []);

    // Filtra a lista conforme a role do usuário logado. Se a role estiver no
    // mapa, restringe à doc daquele cliente; caso contrário mostra tudo.
    const allowedSlug = ROLE_TO_DOC_SLUG[user?.role];
    const visibleDocs = allowedSlug
        ? docs.filter((d) => d.slug === allowedSlug)
        : docs;

    return (
        <div className="flex w-full h-full justify-center items-start py-4 px-4 bg-gray-200">
            <div className="flex flex-col w-full h-full rounded-xl py-8 px-6 gap-6 bg-white">
                <div className="flex items-center gap-2 text-md font-semibold ps-2">
                    <FaBookOpen size={20} className="text-gray-600" />
                    Documentação das APIs
                </div>

                {loading && (
                    <div className="text-sm text-gray-500 ps-2">Carregando...</div>
                )}

                {error && (
                    <div className="text-sm text-red-600 ps-2">{error}</div>
                )}

                {!loading && !error && (
                    <ul className="flex flex-col gap-2 ps-2">
                        {visibleDocs.map((d) => (
                            <li key={d.slug}>
                                <Link
                                    to={`/app/docs/${d.slug}`}
                                    className="flex items-center justify-between gap-3 px-4 py-3 rounded-lg border border-gray-200 hover:border-blue-500 hover:bg-blue-50 transition"
                                >
                                    <div className="flex flex-col">
                                        <span className="font-semibold text-gray-800">{d.title}</span>
                                        <span className="text-xs text-gray-500">
                                            {d.updatedAt
                                                ? `Atualizada em ${new Date(d.updatedAt).toLocaleString()}`
                                                : "—"}
                                        </span>
                                    </div>
                                    <FaArrowRight className="text-gray-400" />
                                </Link>
                            </li>
                        ))}
                        {visibleDocs.length === 0 && (
                            <li className="text-sm text-gray-500">Nenhuma documentação disponível.</li>
                        )}
                    </ul>
                )}
            </div>
        </div>
    );
}
